<template>
  <div class="collectionForm">
    <base-form
      v-model="baseData"
      :options="baseDataOptions"
      ref="baseData"
      :disabled="fundPaymentBillFlag == '1' ? true : !isEdit || !canEdit"
      @input="handleChangeBaseData"
      label-width="105px"
    ></base-form>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  export default {
    name: 'collectionForm',
    components: {
      baseForm,
    },
    props: ['isEdit', 'canEdit', 'fundPaymentBillFlag'],
    data() {
      return {
        baseData: {
          id: null,
          collectionBankNo: null,
          collectionBankName: null,
          collectionBankAccount: null,
          collectionCashFlowCode: null,
          collectionDate: null,
          actualReceiptDate: null,
          collectionReturnDate: null,
          serviceCharge: null,
          serviceChargeType: null,
          serviceChargeSerialNumber: null,
        },
      };
    },
    computed: {
      baseDataOptions() {
        //基础数据表单配置
        return [
          {
            // 托收银行
            type: 'searchTable',
            prop: 'collectionBankName',
            searchType: 'bankAccount',
            isMultiple: true,
            label: this.$t('billDetail.collectionForm.collectionBankNo'),
            name: 'collectionBankName',
            getName: 'branchName',
            currentValue: this.baseData.collectionBankName,
          },
          {
            // 托收银行账号
            type: 'input',
            label: this.$t('billDetail.collectionForm.collectionBankAccount'),
            prop: 'collectionBankAccount',
            placeholder: this.$t('billDetail.placeholder.auto'),
            disabled: true,
          },
          {
            // 托收日期
            type: 'date',
            label: this.$t('billDetail.collectionForm.collectionDate'),
            prop: 'collectionDate',
          },
          {
            // 实际收款日期
            type: 'date',
            label: this.$t('billDetail.collectionForm.actualReceiptDate'),
            prop: 'actualReceiptDate',
          },
          {
            // 托收退回日期
            type: 'date',
            label: this.$t('billDetail.collectionForm.collectionReturnDate'),
            prop: 'collectionReturnDate',
          },
          {
            // 手续费
            type: 'amountNumber',
            label: this.$t('billDetail.collectionForm.serviceCharge'),
            prop: 'serviceCharge',
            max: 99999999999.99,
            min: 0,
          },
          // { // 手续费科目
          //   type: "searchTable",
          //   prop: "serviceChargeType",
          //   searchType: 'account',
          //   isMultiple: true,
          //   label: this.$t("billDetail.collectionForm.serviceChargeType"),
          //   currentValue: this.baseData.serviceChargeType,
          // },
          // { // 手续费现金流量代码
          //   type: "searchTable",
          //   label: this.$t("billDetail.collectionForm.serviceChargeSerialNumber"),
          //   prop: "serviceChargeSerialNumber",
          //   searchType: 'cashflow',
          //   isMultiple: true,
          //   currentValue: this.baseData.serviceChargeSerialNumber,
          // },
          // { // 托收现金流量代码
          //   type: "searchTable",
          //   label: this.$t("billDetail.collectionForm.collectionCashFlowCode"),
          //   prop: "collectionCashFlowCode",
          //   searchType: 'cashflow',
          //   isMultiple: true,
          //   currentValue: this.baseData.collectionCashFlowCode,
          // },
        ];
      },
    },
    methods: {
      handleChangeBaseData(value, prop) {
        //基本数据表单变化
        if (prop == 'serviceChargeType') {
          // 手续费科目
          this.searchTableChange(value.serviceChargeType, [
            { val: 'serviceChargeType', getVal: 'accountCode' },
          ]);
        } else if (prop == 'collectionBankName') {
          this.searchTableChange(value.collectionBankName, [
            { val: 'collectionBankName', getVal: 'branchName' },
            { val: 'collectionBankNo', getVal: 'branchCode' },
            { val: 'collectionBankAccount', getVal: 'bankAccountNum' },
          ]);
        } else if (['collectionCashFlowCode', 'serviceChargeSerialNumber'].indexOf(prop) != -1) {
          // 现金流量代码
          this.searchTableChange(value[prop], [{ val: prop, getVal: 'cashflowCode' }]);
        }
      },
      searchTableChange(val, fooArr) {
        if (val && val.length > 0) {
          fooArr.map((item) => {
            if (item.getVal) {
              this.baseData[item.val] = val[0][item.getVal];
            } else {
              this.baseData[item.val] = val[0][item.val];
            }
          });
        } else {
          fooArr.map((item) => {
            this.baseData[item.val] = null;
          });
        }
      },
      exportChildData() {
        // 返回数据
        let sign = false;
        this.$refs.baseData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
          } else {
            sign = false;
          }
        });
        return sign ? this.baseData : false;
      },
    },
  };
</script>
